import { useState, useCallback } from 'react';
import { UsersApi } from '../../clients';

export const useChangeFacilityUserRole = () => {
  const [state, setState] = useState({
    loading: false,
    error: null,
  });

  const changeRole = useCallback(async (facilityUserId, roleId) => {
    setState({
      loading: true,
      error: null,
    });

    try {
      const response = await UsersApi.changeFacilityUserRole(
        facilityUserId,
        roleId,
      );
      setState({
        loading: false,
        error: null,
      });
      return response.data;
    } catch (error) {
      console.error('Error changing facility user role:', error);
      setState({
        loading: false,
        error: error.response?.data?.message || 'Failed to change user role',
      });
      throw error;
    }
  }, []);

  return {
    ...state,
    changeRole,
  };
};
